import { UserClientDto } from "./user-client-dto";
import { UserRoleDto } from "./user-role-dto";

export class UserRoleDetailDto {
    userClientDto: UserClientDto;
    userRoleDto: UserRoleDto;
}